import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

function ContentDefaultLoader() {
  return (
    <Box
      width='100dvw'
      height='100dvh'
      display='flex'
      flexDirection='column'
      alignItems='center'
      gap={2}
      padding={2}
    >
      <Skeleton variant='rounded' height={100} width='100%' />
      <Skeleton variant='rounded' height={100} width='100%' />
      <Skeleton variant='rounded' height={100} width='100%' />
      <Skeleton variant='rounded' height={100} width='100%' />
    </Box>
  );
}

export default ContentDefaultLoader;
